import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueI18n from 'vue-i18n'
import en from "./i18n/en.json";
import fi from "./i18n/fi.json";
import se from "./i18n/se.json";
// import { defaultLocale, messages } from "./i18n/setup";

import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_BASEURL;

const Locales = {
	EN : 'en',
	FI : 'fi',
	SE : 'se'
}

const messages = {
	[Locales.EN]: en,
	[Locales.FI]: fi,
	[Locales.SE]: se
};

const defaultLocale = Locales.FI;


if(axios.defaults.baseURL == "api/"){
	axios.defaults.baseURL = location.protocol + "//" + location.host + "/api/";
}

//console.log(process.env.VUE_APP_API_BASEURL)

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueI18n)
Vue.config.productionTip = false;


const i18n = new VueI18n({
	messages,
	locale: defaultLocale,
	fallbackLocale: defaultLocale
})

Vue.use(i18n)

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app");
